import { celsius_to_fahrenheit, real_id } from '../../../../helpers/interface_helpers';
import { format } from 'svelte-i18n';
import { get } from 'svelte/store';
import { devices_settings } from 'src/stores/device-runtime/status';
import { CAMERA_ACTION_NAMES } from 'src/components/Scenes/helpers/camera_action_helpers';
import { getCameraSoundLabel } from 'src/components/Camera/helpers/camera-sounds';
import { getCameraZoneName } from 'src/components/Scenes/SceneWizard/Process/When/AddEditContionWizard/Steps/DeviceBased/helpers/camera-scene-helpers';

let _format;
let _f = format.subscribe((e) => (_format = e));

export function COMMAND_TO_I18N_ACTION_MSG(action: any = { name: '', value: '' }, gen = 1, device_id) {
	const { name, value } = action;
	let settings = get(devices_settings);
	switch (name) {
		case 'turn':
		case 'state':
			if (value === 'toggle') {
				return _format('command_toggle_state', {
					default: 'Toggle the state of the device',
				});
			}
			return (
				_format(`command_turn_state`, {
					values: { turn_state: _format(`label_action_turn_${value}`) },
				}) || `Turn ${value} the device.`
			);
		case 'turn_add_on':
			return (
				_format(`scene_action_turn_add_on_state`, {
					values: { turn_state: _format(`label_action_turn_${value}`) },
				}) || `Turn ${value} the add-on.`
			);

		case 'roller state':
		case 'roller direction':
		case 'multi_cover_state':
			return gen === 2
				? _format('command_device_state', {
						values: { command: _format(`execute_${value}`) },
					})
				: _format('command_roller_state', {
						values: {
							roller_state: _format(`execute_${value}`),
						},
					}) || `${value} the device`;

		case 'roller position':
		case 'multi_cover_position':
			return _format('command_set_position', {
				values: { n: value },
			});

		case 'blinds_tilt_position':
		case 'multi_cover_blinds_tilt_position':
			return _format('command_set_blinds_tilt_position', {
				default: `set blinds tilt position to ${value}%`,
				values: { n: value },
			});

		case 'brightness':
			return _format('command_brightness', {
				values: { n: value },
			});

		case 'white_channel':
			return (
				_format('command_white_channel', {
					values: { n: value },
					default: `Set white channel to ${value} %`,
				}) || 'Set white channel to ' + value
			);
		case 'temp':
			return _format('command_color_temp', {
				values: { n: value },
			});
		case 'mode':
		case 'r':
		case 'g':
		case 'b':
			return '';
		case 'target_temp':
		case 'set_temp':
			let units: any = settings[real_id(device_id)]?.thermostats?.[0]?.target_t?.units || 'C';
			let _value: string | number = units === 'F' ? celsius_to_fahrenheit(Number(value)) : value;

			return _format('command_temperature', {
				default: `set temperature to ${value} °${units}`,
				values: {
					units: units || 'C',
					value: _value,
				},
			});
		case 'set_profile':
			let profile_name =
				settings[real_id(device_id)]?.thermostats?.[0]?.schedule_profile_names[
					Number(value) - 1
				] || 'Profile ' + value;
			return _format('command_apply_profile', {
				default: `apply ${profile_name}`,
				values: { name: profile_name },
			});

		case 'report_window_open':
			return action[0]?.value === 'on'
				? _format('command_report_window_open', {
						default: `Send \"window open\"`,
					})
				: _format('command_report_window_close', {
						default: `Send \"window close\"`,
					});

		case 'boost':
			return _format('command_start_boost', {
				default: `Activate/ Start boost`,
			});
		case 'transition_duration':
			return _format('command_transition_duration', {
				default: `Set transition duration`,
			});
		case 'bolt_state':
			return `Set lock state`;
		case 'fan_mode':
			return _format(value === 'auto' ? 'ventora_run_mode_auto' : 'ventora_run_mode_manual', {
				default: value === 'auto' ? 'Auto' : 'Manual',
			});
		case 'fan_on':
			return _format('scene_action_turn_state', {
				values: { turn_state: _format(`label_action_turn_${value}`) },
			});
		case 'fan_speed':
			return _format('ventora_manual_mode_speed', {
				values: { speed: value },
				default: 'Speed {speed}%',
			});
		case 'cury_intensity': {
			const slot = action.slot || 'left';
			const slotText =
				slot === 'left'
					? _format('left_slot', { default: 'Left' }).toLowerCase()
					: _format('right_slot', { default: 'Right' }).toLowerCase();
			return _format('command_cury_intensity', {
				default: 'Set {slot} slot intensity',
				values: { slot: slotText },
			});
		}
		case 'cury_boost': {
			const slot = action.slot || 'left';
			const slotText =
				slot === 'left'
					? _format('left_slot', { default: 'Left' }).toLowerCase()
					: _format('right_slot', { default: 'Right' }).toLowerCase();
			return _format('command_cury_boost_vial', {
				default: 'Boost {slot} vial',
				values: { slot: slotText },
			});
		}
		case 'cury_stop': {
			const slot = action.slot || 'left';
			const slotText =
				slot === 'left'
					? _format('left_slot', { default: 'Left' }).toLowerCase()
					: _format('right_slot', { default: 'Right' }).toLowerCase();
			return _format('command_cury_stop_boost', {
				default: 'Stop boost {slot} slot',
				values: { slot: slotText },
			});
		}
		case 'cury_on': {
			const slot = action.slot || 'left';
			const slotText =
				slot === 'left'
					? _format('left_slot', { default: 'Left' }).toLowerCase()
					: _format('right_slot', { default: 'Right' }).toLowerCase();
			const isOn = value !== false;
			return isOn
				? _format('command_cury_vial_on', {
						default: 'Turn on {slot} vial',
						values: { slot: slotText },
					})
				: _format('command_cury_vial_off', {
						default: 'Turn off {slot} vial',
						values: { slot: slotText },
					});
		}
		case 'cury_ambient': {
			return value?.enable
				? _format('command_cury_ambient_enable', {
						default: 'Enable ambient light',
					})
				: _format('command_cury_ambient_disable', {
						default: 'Disable ambient light',
					});
		}
		case CAMERA_ACTION_NAMES.CAPTURE:
			return _format('command_camera_capture_image', { default: 'Capture image' });
		case CAMERA_ACTION_NAMES.RECORD: {
			const durationValue = (action as any)?.duration;
			const base = _format('command_camera_start_recording', { default: 'Start recording' });
			return durationValue != null
				? `${base} (${durationValue} ${_format('timer_text_sec', { default: 'sec' })})`
				: base;
		}
		case CAMERA_ACTION_NAMES.ARM:
			return value === 'true'
				? _format('label_action_alarm_arm', { default: 'Arm' })
				: _format('label_action_alarm_disarm', { default: 'Disarm' });
		case CAMERA_ACTION_NAMES.PRIVACY:
			return value === 'true'
				? _format('command_camera_privacy_on', { default: 'Enable privacy mode' })
				: _format('command_camera_privacy_off', { default: 'Disable privacy mode' });
		case CAMERA_ACTION_NAMES.PLAY_SOUND:
			return _format('command_camera_play_sound', {
				default: 'Play sound: {sound}',
				values: { sound: getCameraSoundLabel(value) },
			});
		case CAMERA_ACTION_NAMES.ZONE: {
			const zoneId = (action as any)?.add_info_ind ?? (action as any)?.addOnInd;
			const zoneName = getCameraZoneName(zoneId, settings[real_id(device_id)]);
			return value === 'true'
				? _format('command_camera_zone_enable', {
						default: 'Enable zone {zone}',
						values: { zone: zoneName },
					})
				: _format('command_camera_zone_disable', {
						default: 'Disable zone {zone}',
						values: { zone: zoneName },
					});
		}

		default:
			return '';
	}
}
